/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfUserAssignedApp } from "../models/AjaxResponseOfListOfUserAssignedApp";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class CredentialsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfListOfUserAssignedApp Success
   * @throws ApiError
   */
  public getAllApps(): CancelablePromise<AjaxResponseOfListOfUserAssignedApp> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/credentials/get-all",
    });
  }
}
